import React, { useContext } from "react";
import {
  LoadingOutlined,
  PauseCircleFilled,
  PlayCircleFilled,
} from "@ant-design/icons";
import TimeShower from "../../../../components/TimeShower";
import { VoiceContext } from "../../../chat/voicePlayer.context";
import { Slider, Spin } from "antd";

const VoicePlayer = (props) => {
  const { url, id } = props;
  const { play, playlist, seekTo } = useContext(VoiceContext);

  const formatter = (value) => {
    const duration = playlist[id]?.duration;
    if (value && duration) {
      const current = (value / 100) * duration;
      return `${Math.floor(current / 60)
        .toString()
        .padStart(2, "0")}:${Math.floor(current % 60)
        .toString()
        .padStart(2, "0")}`;
    }
    return "00:00";
  };

  return (
    <>
      <div className="msg-voice-player">
        <div
          className="control-wrapper center-flex"
          onClick={() => play(id, url)}
        >
          {playlist[id]?.status === "playing" ? (
            <PauseCircleFilled className="control pause" />
          ) : playlist[id]?.status === "loading" ? (
            <Spin
              className="control"
              indicator={<LoadingOutlined style={{ fontSize: "21px" }} spin />}
            />
          ) : (
            <PlayCircleFilled className="control play" />
          )}
        </div>
        <div className="duration center-flex">
          {playlist[id]?.duration && playlist[id]?.duration !== 0 ? (
            <TimeShower time={playlist[id]?.duration.toFixed(0)} />
          ) : (
            "--:--"
          )}
        </div>
        <Slider
          className="slider"
          reverse={true}
          disabled={!playlist[id] || playlist[id].status === "loading"}
          tooltip={{ formatter }}
          value={
            ((playlist[id]?.currentTime || 0) / (playlist[id]?.duration || 0)) *
            100
          }
          onChange={(value) => seekTo(value, playlist[id]?.element)}
        />
      </div>
    </>
  );
};

export default VoicePlayer;
